/**
 * @function throttle
 * @memberof Promega.Util
 * @description Returns a function, that, when invoked, will only be triggered at most once during a given window of time. Normally, the throttled function will run as much as it can, without ever going more than once per <code>wait</code> duration
 * @param {Function} func The input function to modify
 * @param {Number} wait The number of milliseconds to wait before firing the function
 * @param {JSON} [options] Options to configure the throttled function that is returned.
 * @param {Boolean} options.leading If false, disables execution on the leading edge.
 * @param {Boolean} options.trailing If false, disables execution on the trailing edge.
 * @returns {Function} A new version of the function that will be throttled when called
 */
export default function throttle (func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
    };
    return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
        if (timeout) {
        clearTimeout(timeout);
        timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
    }
    return result;
    };
}
